import { CLEAR_CLONE_DATA, CLONE_EVENT } from 'redux/Actions/EventClone/Type'

const initialState = {
  events: null,
}

const eventReducer = (state = initialState, action: any) => {
  
  switch (action.type) {
    case CLONE_EVENT:
      return {
        ...state,
        events: action.payload,
      }
    case CLEAR_CLONE_DATA:
      return {
        ...state,
        events: null,
      }

    default:
      return state
  }
}

export default eventReducer
